import amexSrc from './assets/card-brands/amex.svg?url'
import discoverSrc from './assets/card-brands/discover.svg?url'
import mastercardSrc from './assets/card-brands/mastercard.svg?url'
import visaSrc from './assets/card-brands/visa.svg?url'
import type { CreditCardType } from './creditCardTypes'

export interface CreditCardBrandAsset {
  brand: CreditCardType
  label: string
  src: string
}

export const CREDIT_CARD_BRAND_ORDER: readonly CreditCardType[] = [
  'amex',
  'discover',
  'mastercard',
  'visa',
]

const CREDIT_CARD_BRAND_ASSETS: Record<
  CreditCardType,
  CreditCardBrandAsset
> = {
  amex: {
    brand: 'amex',
    label: 'American Express', // i18n-exempt: official payment network name
    src: amexSrc,
  },
  discover: { brand: 'discover', label: 'Discover', src: discoverSrc }, // i18n-exempt: official payment network name
  mastercard: {
    brand: 'mastercard',
    label: 'Mastercard', // i18n-exempt: official payment network name
    src: mastercardSrc,
  },
  visa: { brand: 'visa', label: 'Visa', src: visaSrc }, // i18n-exempt: official payment network name
}

export function getCreditCardBrandAsset(
  brand: CreditCardType,
): CreditCardBrandAsset {
  return CREDIT_CARD_BRAND_ASSETS[brand]
}
